import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';

import { withRouter } from 'react-router-dom';
import { EventInviteStatus } from '../../../../utils/events';
import { splitTitle } from '../../../../utils/formatting';
import styles from '../../../../pages/EventProfiles/event.scss';
import SportLabel from '../../../cards/CardComponents/SportLabel';

function CreatePlayHeader(props) {
    const { event, currentMemberInvite, currentUserId, onPlayClicked, onPassClicked } = props;
    const { eventEndUtc } = event.eventSchedule;
    const { registeredMemberIds } = event;
    const eventHasEnded = moment(eventEndUtc).isBefore(moment());
    const inviteStatus = currentMemberInvite?.status;
    const hasAccepted = inviteStatus === EventInviteStatus.ACCEPTED;
    const hasDeclined = inviteStatus === EventInviteStatus.DECLINED;
    const isCurrentUserRegistered = registeredMemberIds.includes(currentUserId);
    const isInvited = inviteStatus === EventInviteStatus.INVITED;
    const showPlayButton = (!inviteStatus && !isCurrentUserRegistered) || isInvited || hasDeclined;
    const showPassButton = (!inviteStatus && isCurrentUserRegistered) || isInvited || hasAccepted;

    const handleOnPlayClicked = () => {
        onPlayClicked(event.id);
    };

    const handleOnPassClicked = () => {
        onPassClicked(event.id);
    };

    return (
        <div className={`${styles.section} bottom-border header`}>
            <div className={`container pb0`}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex flex-row align-items-center">
                            <div className="flex-grow" />
                            <div
                                className="ml16 mb8 d-none d-md-block cursor-pointer"
                                onClick={() => {
                                    props.showShareUrlPopup();
                                }}
                            >
                                <span><i className="uts uts-share" />Share</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="event-title">
                            {event?.sportTypeId && <SportLabel className="mb8" sportTypeId={event.sportTypeId} />}
                            <h2
                                className={`text-semi mb8`}
                            >
                                {splitTitle(event.name).firstPart}
                                <span className={`${event.utrType.id === 2 ? 'verified' : 'unverified'}`}>
                                    {splitTitle(event.name).lastPart}
                                    <span className={`${event?.hasPrizeMoney ? 'prizeEventIcon fal fa-usd-circle' : 'noPrizeMoney'}`}>
                                        {/* {event?.hasSafeSportCertifiedOrganizer && (
                                            <span
                                                className="safeSportCertified"
                                                onClick={() => {
                                                    this.setState({
                                                        showSafeSportPopup: true,
                                                    });
                                                }}
                                            />
                                        )} */}
                                    </span>
                                </span>
                            </h2>
                            <h6 className="subtitle text-medium text-gray text-uppercase mb24">
                                <span>{event?.eventSchedule.eventDatesShort}</span>
                                <span className={`d-none d-md-inline-block middleDot`}>&nbsp;</span>
                                <br className="d-block d-md-none" />
                                <span>{_.get(event, 'eventLocations', []).length && (event.eventLocations[0].placeName || event.eventLocations[0].display)} </span>
                                <span className={`d-none d-md-inline-block middleDot`}>&nbsp;</span>
                                <br className="d-block d-md-none" />
                                <span>{event?.priceRange}</span>
                                {(hasAccepted || isCurrentUserRegistered) && (
                                    <span className="tag tag-teal ml16">You&apos;re playing</span>
                                )}
                                {hasDeclined && (
                                    <span className="tag tag-grey ml16">You passed</span>
                                )}

                                {event?.hasPrizeMoney && (
                                    <>
                                        <span className={`d-none d-md-inline-block middleDot`}>&nbsp;</span>
                                        <br className="d-block d-md-none" />
                                        <span>{event.prizeMoneyText}</span>
                                    </>
                                )}
                                <br className="d-block d-md-none" />
                                <span
                                    className="d-block d-md-none cursor-pointer"
                                    onClick={() => {
                                        props.showShareUrlPopup();
                                    }}
                                >
                                    <span><i className="uts uts-share" />Share</span>
                                </span>
                            </h6>
                        </div>
                    </div>
                    {!eventHasEnded && (
                        <div className="col-12 mb40">
                            {showPassButton && (
                                <button
                                    type="button"
                                    className="btn btn-default text-uppercase mr16 mb8"
                                    onClick={handleOnPassClicked}
                                >
                                    {hasAccepted ? 'Can\'t Make It' : 'I\'ll Pass'}
                                </button>
                            )}
                            {showPlayButton && (
                                <button
                                    type="button"
                                    className="btn btn-primary text-uppercase mb8"
                                    onClick={handleOnPlayClicked}
                                >
                                    I&apos;ll Play
                                </button>
                            )}
                        </div>
                    )}
                    {eventHasEnded && (
                        <div className="col-12 mb40">
                            <button
                                type="button"
                                className="btn btn-default text-uppercase mr16 mb8"
                                disabled
                            >
                                Event has ended
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default withRouter(CreatePlayHeader);
